import * as React from "react";
import { Box, Grid, Hidden, makeStyles } from "@material-ui/core";
import { themeVariables } from "../_Theme";
import { prepareWasOnline, prepareLastActivity, tl } from "../../../../utils";
import { MUITagsCard } from "../TagsCard";
import cx from "classnames";
import * as styles from "./styles.scss";
import { observer } from "mobx-react";
import { IStudent } from "../../../../typings/IStudent";
import { Clear } from "@material-ui/icons";
import classNames from "classnames";

interface IProps {
  user: IStudent;
  isTags?: boolean;
  isActivity?: boolean;
  isActivityMobile?: boolean;
  tagsMoreToCollaps?: number;
  userNameShort?: boolean;
  mirrored?: boolean;
  showEmail?: boolean;
  showLastName?: boolean;
  extendRow?: boolean;
  date?: string;
  size?: 32 | 36 | 40 | null;
  onMouseOver?: React.MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>;

}

export const MUIUserCard = observer(React.forwardRef((props: IProps, ref) => {
  const {
    user,
    isTags,
    isActivity,
    isActivityMobile,
    tagsMoreToCollaps,
    userNameShort,
    mirrored,
    showEmail,
    showLastName,
    extendRow,
    date,
    size,
    onMouseOver,
    onMouseLeave
  } = props;
  const wasOnline = prepareWasOnline(
    user.wasOnline
  ).map((item: string, index: number) => (
    <div key={`wasOnline-${Math.random()}`}>{item}</div>
  ));

  const classes = makeStyles({
    online: {
      "&:after": { backgroundColor: themeVariables.palette.success.main },
    },
    offline: {
      "&:after": { backgroundColor: themeVariables.palette.error.main },
    },
    userName: {},
    nameContainer: {
      "&:hover": {
        "& $userWidth": {
          maxWidth: 'max-content',
        },
        "& $userName": {
          background: '#fff',
        }
      }
    },
    userWidth: {
      maxWidth: userNameShort ? "130px" : "200px",
      [themeVariables.breakpoints.down("lg")]: {
        maxWidth: "130px",
      },
      [themeVariables.breakpoints.down("sm")]: {
        maxWidth: "250px",
      },
    },
    userImg: {
      width: `${size ? size : 40}px`,
      height: `${size ? size : 40}px`,
    },
    activityText: {
      fontSize: 12,
      lineHeight: '14px',
      color: themeVariables.palette.grey[600]
    }
  })({});

  return (
    <Grid
      container
      alignItems="center"
      wrap="nowrap"
      spacing={1}
      direction={mirrored ? "row-reverse" : "row"}
      className={extendRow ? classes.nameContainer: ''}
    >
      <Grid item>
       {user.isRetired 
        ? <Box className={styles.userRetired} pt={size ? 0 : 0.5} >
            <Clear color="inherit" fontSize="inherit"  />
          </Box>
        :  <Box
            className={cx(styles.userImg, {
              [classes.online]: user.isOnline,
              [classes.offline]: !user.isOnline,
            })}
            pt={size ? 0 : 0.5}
          >
            <img
              className={classes.userImg}
              src={
                user.avatar
                  ? `/media/80/${window.btoa(user.avatar)}`
                  : `/public/images/_anti/panel/student-default.svg`
              }
            />
          </Box>
      }
      </Grid>
      <Box clone overflow="hidden">
        <Grid 
          item 
          className={!user.tags?.length ? styles.flexCentered : null}
        >
          <Grid container direction={mirrored ? "row-reverse" : "column"}>
            <Grid item>
              <Grid container spacing={1} wrap={mirrored ? "wrap" : "nowrap"}>
                <Box clone color={themeVariables.palette.common.black}>
                  <Grid 
                    item 
                    className={classNames(classes.userName, styles.userName)}
                    aria-owns={"simple-menu"+user.id} 
                    //@ts-ignore
                    innerRef={ref}
                    aria-haspopup="true"
                    onMouseOver={onMouseOver}
                    onMouseLeave={onMouseLeave}
                    style={{cursor: 'context-menu'}}
                  >
                    <Box
                      className={
                        mirrored && date
                          ? styles.userDate
                          : cx(styles.hideLong, classes.userWidth)
                      }
                    >
                      {mirrored && date ? date : (showLastName && user.lastName ? `${user.name} ${user.lastName}` : user.name)}
                    </Box>
                    {showEmail ? (
                      <Box
                        className={`${styles.hideLong} ${classes.userWidth} ${styles.userNameSmall}`}
                        color={themeVariables.palette.grey[600]}
                        
                      >
                        {user.email}
                      </Box>
                    ) : null}
                    {mirrored && date ? (
                      <Box
                        className={`${styles.hideLong} ${classes.userWidth} ${styles.userNameSmall}`}
                        color={themeVariables.palette.grey[600]}
                        
                      >
                        {showLastName && user.lastName ? `${user.name} ${user.lastName}` : user.name}
                      </Box>
                    ) : null}
                  </Grid>
                </Box>
                {isActivityMobile ? (
                  <Hidden smUp>
                    <Grid item>
                      <Box mr={2} className={classes.activityText}>{wasOnline}</Box>
                    </Grid>
                  </Hidden>
                ) : null}
              </Grid>
            </Grid>
            <Grid item>
              {isTags && user.tags ? (
                <MUITagsCard
                  tags={user.isRetired ? [{color: '#AA3729', tag: tl('Ученик удалил свой аккаунт'), id: -1, course: 0,}] :user.tags}
                  tagsMoreToCollaps={tagsMoreToCollaps}
                />
              ) : null}
              {isActivity && wasOnline ? (
                <Box className={classes.activityText}>{prepareLastActivity(user.wasOnline)}</Box>
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}));
